import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';

import './digital-skills-resource-type-select.css';

// TODO: Move this component to the UI Library and make it reusable & enable multi-select once api is updated

interface DigitalSkillsResourceTypeSelectProps {
  value: string[];
  options: {
    label: string;
    value: string;
  }[];
  onChange: (value: string[]) => void;
  label: string;
}

const DigitalSkillsResourceTypeSelect: React.FC<DigitalSkillsResourceTypeSelectProps> = ({
  value,
  options,
  onChange,
  label,
}) => {
  const customSelectedItemsLabel = () => {
    return <>Type</>;
  };
  const itemTemplate = (option: { label: string; value: string }) => {
    const labelId = `dsrt_${option.value}`;
    const isSelected = value.includes(option.value);

    // <ul class="p-multiselect-items p-component" role="listbox" aria-multiselectable="true" data-pc-section="list"></ul>
    return (
      <div className="digitalSkillsResourceTypeSelectOption">
        <div
          id={labelId}
          className="optionItem"
        >
          {option.label}
        </div>
        <Checkbox
          aria-labelledby={labelId}
          style={{
            display: 'none',
          }}
          checked={isSelected}
          onChange={() => {
            if (isSelected) {
              onChange(value.filter((v) => v !== option.value));
            } else {
              onChange([...value, option.value]);
            }
          }}
        />

        {isSelected ? (
          <i
            className="fa-solid fa-check-square"
            style={{ color: 'var(--light-text-highlight)' }}
          ></i>
        ) : (
          <i className="fa-regular fa-square"></i>
        )}
      </div>
    );
  };

  return (
    <div className="digitalSkillsResourceTypeSelect">
      <MultiSelect
        id="resourceTypeMultiSelect"
        appendTo="self"
        value={value}
        onChange={(e) => onChange(e.value)}
        options={options}
        optionLabel="label"
        placeholder="Select Resource Type"
        selectedItemTemplate={customSelectedItemsLabel}
        maxSelectedLabels={0}
        selectedItemsLabel={`{value.length} Type`}
        itemTemplate={itemTemplate}
        itemCheckboxIcon="pi pi-check"
        aria-label={label}
        role="search"
        pt={{
          input: {
            autoComplete: 'off',
            'aria-label': label,
            'aria-controls': 'resourceTypeMultiSelect',
          },
          list: {
            'aria-label': label,
          },
          wrapper: {
            tabIndex: 0,
            role: 'complementary',
          },
        }}
      />
    </div>
  );
};

export default DigitalSkillsResourceTypeSelect;
